import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getFromStorage, getSessionId, saveToStorageAsync } from '../../helpers/storageUtils';
import { YaTenemosEstado } from '../../Models/ya-tenemos-datos-estado.enum';
import { FEEDBACK } from '../../routes.constans';
import { BannerAppComponent } from '../banner-app/banner-app.component';
import { FooterAppComponent } from '../footer-app/footer-app.component';

@Component({
  selector: 'app-tiempo-inactivo',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './tiempo-inactivo.component.html',
  styleUrl: './tiempo-inactivo.component.scss',
})
export class TiempoInactivoComponent {
  sessionId = '';
  codAsesor = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.sessionId = getSessionId().toString();
  }

  async cotizacionEnPausa() {
    const rutaOrigen = await getFromStorage('ruta-inactividad', 'session');
    let valor = -1;

    switch (rutaOrigen) {
      case 'planes':
        valor = YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES;
        break;
      case 'datos-restantes':
        valor = YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES;
        break;
      case 'cotizador':
        valor = YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES;
        break;
      case 'resumen':
        valor = YaTenemosEstado.LEAD_ABANDONO_RESUMEN;
        break;
      default:
        valor = YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES;
        break;
    }
    await saveToStorageAsync('ya_tenemos_tus_datos', valor, 'session');
    this.router.navigate([FEEDBACK]);
  }

  async contactarAsesor() {
    await saveToStorageAsync(
      'ya_tenemos_tus_datos',
      YaTenemosEstado.LEAD_ABANDONO_PAGINA_PLANES,
      'session',
    );
    this.router.navigate([FEEDBACK]);
  }

  volverAlInicio() {
    if (this.codAsesor === undefined || this.codAsesor === '') {
      this.router.navigate(['/inicio']);
    } else {
      this.router.navigate(['/inicio'], { queryParams: { codigoAsesor: this.codAsesor } });
    }
  }

  goBack(): void {
    window.history.back();
  }
}
